import React, { Component } from "react";
import {
  Table, Form, Popup, Icon, Grid, Button,
  Segment, Dimmer, Loader, Checkbox, Modal,
  Header
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SuggestedActionsReport from "./ts-expert/SuggestedActionsReport";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
//const nameRegex = new RegExp("^[A-Za-z][A-Za-z-]*");

const UtilsInstance = new Utils();

class InterfaceCounters extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      formInput: "",
      column: null,
      sortDirection: null,
      originalDevices: [],
      devices: [],
      suggestedActionsReport: "",
      isGenerateSuggestedActionsReportDimmerActive: false,
      isErrorDevicesToggleChecked: false,
      isIntelligentFilterToggleChecked: false,
      isFirstFilterRetrieve: true,
      isModalOpen: false,
      turnText: Strings.TURN_ON
    };
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the name passed on the form
  handleNameAndModelSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].name != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].name.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
        else if (this.state.originalDevices[i].model.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    // else if (this.state.formInput !== "" && nameRegex.test(this.state.formInput)) {
    //   this.handleNameAndModelSearch();
    // }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Only retrieve data if the form is empty and the errors toggle is not checked
    if (this.state.formInput === "" && !this.state.isErrorDevicesToggleChecked) {

      // Only get the filter state when this variable is true
      if (this.state.isFirstFilterRetrieve) {
        let promissesArray = [];

        // Retrieve devices list
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "interfaceCounters", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        // Retrieve the intelligent filter state
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "filterPortsState", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        let resolvedPromisses = await Promise.all(promissesArray);

        let devices = resolvedPromisses[0].sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        });

        let portStateFilter = resolvedPromisses[1];

        this.setState({
          devices: devices,
          originalDevices: devices,
          isIntelligentFilterToggleChecked: portStateFilter.filter,
          isFirstFilterRetrieve: false
        });

      }
      else {
        // Retrieve devices list
        fetch(Constants.REQUEST_IP_ADDRESS + "interfaceCounters", { mode: "cors" })
          .then(res => res.json())
          .then((data) => {
            // Sort the devices by IP
            let devicesCopy = data.sort((a, b) => {
              const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              return num1 - num2;
            });
            this.setState({
              devices: devicesCopy,
              originalDevices: devicesCopy
            });
          });
      }
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_DIAGNOSTIC;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getCounterCell = (value, delta) => {
    if (parseInt(delta) > 0) {
      return (
        <Table.Cell
          verticalAlign="middle"
          style={errorTableCellStyle}>
          {value}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          verticalAlign="middle">
          {value}
        </Table.Cell>
      );
    }
  }

  getTrafficCell = (kbps) => {
    if (kbps == "") {
      return <Table.Cell verticalAlign="middle">{Strings.ZERO_TRAFFIC}</Table.Cell>;
    }
    else {
      return <Table.Cell verticalAlign="middle">{kbps.toFixed(2)}{Strings.KILOBITS_PER_SECOND_SUFFIX}</Table.Cell>;
    }
  }

  generateSuggestedActionsReport = async () => {
    this.setState({ suggestedActionsReport: "" }, () => {
      this.setGeneratingSuggestedActionsDimmerState(true);
      this.setState({ suggestedActionsReport: <SuggestedActionsReport /> });
    });
  }

  setGeneratingSuggestedActionsDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_SUGGESTIONS_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive });
    }
  }

  /*  
  ------------------------------------------------------------
  ------------------------- Filtros --------------------------
  ------------------------------------------------------------  
*/

  showModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  handleModalCancelClick = () => {
    this.closeModal();
  }

  handleModalOkClick = () => {
    this.alterPortsFilter();
  }

  // Returns true if the device has any input or exit errors or false otherwise
  hasDeviceAnyErrors = (device) => {
    let hasErrors = false;

    for (let i = 0; i < device.instances.length; i++) {
      if ((device.instances[i].in_discards !== "" && parseInt(device.instances[i].in_discards) > 0)
        || (device.instances[i].in_errors !== "" && parseInt(device.instances[i].in_errors) > 0)
        || (device.instances[i].in_unknown_protos !== "" && parseInt(device.instances[i].in_unknown_protos) > 0)
        || (device.instances[i].out_discards !== "" && parseInt(device.instances[i].out_discards) > 0)
        || (device.instances[i].out_errors !== "" && parseInt(device.instances[i].out_errors) > 0)
      ) {
        hasErrors = true;
        break;
      }
    }
    return hasErrors;
  }

  /*
    Decides whether or not to filter the list based on devices that have
    at least one input or one exit error at any of their ports
  */
  toggleErrorDevicesCheckbox = () => {
    // If the toggle is not checked there is something written on the form
    if (this.state.isErrorDevicesToggleChecked === false && this.state.formInput !== "") {
      // Clear the form before toggling the checkbox
      document.getElementById("inputform").value = "";
      this.setState({ formInput: "" }, () => {
        this.setState({ devices: this.state.originalDevices });
      });
    }
    // Now toggle the checkbox
    const toggled = !this.state.isErrorDevicesToggleChecked;
    this.setState({ isErrorDevicesToggleChecked: toggled }, () => {
      const infoLen = this.state.originalDevices.length;
      const searchedDevices = [];

      if (this.state.isErrorDevicesToggleChecked) {
        // Show only Devices that have at least one input or one exit error on any port
        for (let i = 0; i < infoLen; i++) {
          if (this.hasDeviceAnyErrors(this.state.originalDevices[i])) {
            searchedDevices.push(this.state.originalDevices[i]);
          }
        }
        if (searchedDevices.length > 0) {
          this.setState({ devices: searchedDevices });
        } else {
          this.setState({ devices: [] });
        }
      } else {
        // Show all Devices
        this.setState({ devices: this.state.originalDevices });
      }
    });
  }

  toggleIntelligentFilterCheckbox = () => {
    if (this.state.isIntelligentFilterToggleChecked) {
      this.setState({
        turnText: Strings.TURN_OFF,
        isModalOpen: true
      });
    }
    else {
      this.setState({
        turnText: Strings.TURN_ON,
        isModalOpen: true
      });
    }
  }

  alterPortsFilter = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "filterPorts_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ filter: !this.state.isIntelligentFilterToggleChecked })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({
          isIntelligentFilterToggleChecked: !this.state.isIntelligentFilterToggleChecked,
          isFirstFilterRetrieve: true, // let the filter be refreshed once more
        }, () => {
          // refresh the data right after turning the filter on/off
          this.retrieveData();
        });
      })
      .catch((error) => {
        if (this.state.isIntelligentFilterToggleChecked) {
          alert(Strings.PORTS_FILTER_TURN_ON_FAILURE + "\n" + Strings.REASON_DP + error);
        }
        else {
          alert(Strings.PORTS_FILTER_TURN_OFF_FAILURE + "\n" + Strings.REASON_DP + error);
        }
      })
      .finally(() => {
        this.closeModal();
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate = () => {
    this.adjustTableMaxHeight();
  }

  render() {
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => {
      // Only show devices that support this attribute
      if (device.iface_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
        return <React.Fragment key={device.id}>
          <Table.Row style={mainTableRowStyle}>
            <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
            <Table.Cell colSpan="7" />
          </Table.Row>
          {
            device.instances.map(instance => (
              // eslint-disable-next-line react/jsx-key
              <Table.Row>
                <Table.Cell verticalAlign="middle">{instance.interface_label}</Table.Cell>
                {this.getTrafficCell(instance.input_kbps)}
                {this.getCounterCell(instance.in_discards, instance.in_discards_delta)}
                {this.getCounterCell(instance.in_errors, instance.in_errors_delta)}
                {this.getCounterCell(instance.in_unknown_protos, instance.in_unknown_protos_delta)}
                {this.getTrafficCell(instance.exit_kbps)}
                {this.getCounterCell(instance.out_discards, instance.out_discards_delta)}
                {this.getCounterCell(instance.out_errors, instance.out_errors_delta)}
              </Table.Row>
            ))
          }
        </React.Fragment>;
      }
      else if (device.iface_counters_attr_supported === Constants.ATTR_SUP_FALSE) {
        return (
          <Table.Row style={mainTableRowStyle} key={device.id}>
            <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
            <Table.Cell colSpan="7">
              {Strings.INTERFACE_COUNTERS_NOT_SUPPORTED}
            </Table.Cell>
          </Table.Row>
        );
      }
      else {
        return (
          <Table.Row style={mainTableRowStyle} key={device.id}>
            <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
            <Table.Cell colSpan="7">
              {Strings.INTERFACE_COUNTERS_NOT_ANSWERED_YET}
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    return (
      <div style={screenStyle}>
        <Grid columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row style={gridRowStyle}>
            <Grid.Column>
              <Segment id="legend-segment" basic textAlign="center">

                <Button
                  content={Strings.SUGGESTED_ACTIONS_BUTTON}
                  color="teal"
                  onClick={this.generateSuggestedActionsReport} />
                <br />
                <PDFDownloadLink
                  document={this.state.suggestedActionsReport}
                  fileName={Strings.SUGGESTED_ACTIONS_FILENAME}>
                  {({ loading }) => {
                    if (loading) {
                      return Strings.FINISHING;
                    }
                    else {
                      if (this.state.isGenerateSuggestedActionsReportDimmerActive) {
                        this.setGeneratingSuggestedActionsDimmerState(false);
                      }
                      return Strings.SAVE_SUGGESTED_ACTIONS;
                    }
                  }}
                </PDFDownloadLink>

              </Segment>
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.MEDIA_COUNTERS_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Form>
                <Form.Group grouped>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={
                        <label>
                          {Strings.PORTS_FILTER_LABEL}
                          <Popup
                            wide
                            position='bottom right'
                            trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                            <Popup.Content>
                              <p>{Strings.PORTS_FILTER_POPUP_1}</p>
                              <p>{Strings.PORTS_FILTER_POPUP_2}</p>
                            </Popup.Content>
                          </Popup>
                        </label>
                      }
                      onChange={this.toggleIntelligentFilterCheckbox}
                      checked={this.state.isIntelligentFilterToggleChecked} />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={Strings.SHOW_ONLY_ERROR_DEVICES}
                      onChange={this.toggleErrorDevicesCheckbox}
                      checked={this.state.isErrorDevicesToggleChecked} />
                  </Form.Field>
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} compact stackable fixed structured celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2} rowSpan="2">{Strings.IP}</Table.HeaderCell>
              <Table.HeaderCell colSpan="4">{Strings.INPUT}</Table.HeaderCell>
              <Table.HeaderCell colSpan="3">{Strings.OUTPUT}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>

              <Table.HeaderCell>
                {Strings.TRAFFIC_KBPS}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell>
                    {Strings.IN_DISCARDS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.IN_DISCARDS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.IN_DISCARDS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell>
                    {Strings.IN_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.IN_ERRORS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.IN_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell>
                    {Strings.IN_UNKNOWN_PROTOS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.IN_UNKNOWN_PROTOS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.IN_UNKNOWN_PROTOS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Table.HeaderCell>
                {Strings.TRAFFIC_KBPS}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell>
                    {Strings.OUT_DISCARDS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.OUT_DISCARDS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.OUT_DISCARDS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned
                trigger={
                  <Table.HeaderCell>
                    {Strings.OUT_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.OUT_ERRORS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.OUT_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" style={tableBorderStyle} compact stackable fixed structured celled textAlign="center">
            <Table.Body>
              {devices}
            </Table.Body>
          </Table>
        </div>

        <Dimmer page active={this.state.isGenerateSuggestedActionsReportDimmerActive} >
          <Loader size="big">{Strings.GENERATING_ACTIONS_SUGESTIONS_WAITING}</Loader>
        </Dimmer>

        <Modal style={modalStyle} centered open={this.state.isModalOpen} onClose={this.closeModal} size='small'>
          <Header icon='warning sign' content={Strings.ARE_YOU_SURE_YOU_WANT + this.state.turnText + Strings.THE_PORTS_FILTER} />
          <Modal.Content>
            <p>{Strings.PORTS_FILTER_POPUP_1}</p>
            <p>{Strings.PORTS_FILTER_POPUP_2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.handleModalCancelClick}>
              <Icon name='remove' />{Strings.NO}
            </Button>
            <Button color='green' onClick={this.handleModalOkClick}>
              <Icon name='checkmark' />{Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll",
};

const tableBorderStyle = {
  borderCollapse: "separate"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%",
  borderCollapse: "separate"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const mainTableRowStyle = {
  backgroundColor: "#BDBDBD"
};

const errorTableCellStyle = {
  backgroundColor: "#ff6600"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const checkboxStyle = {
  marginTop: "0px"
};

const modalStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30vh",
  height: "275px"
};

const gridRowStyle = {
  paddingBottom: "0px"
};

export default withRouter(InterfaceCounters);
